module.exports = __webpack_public_path__ + "static/media/IconTemplates_-63.4696e527.svg";